import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { CarritoProvider } from "./context/CarritoContext";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      <CarritoProvider>
        <App />
        <ToastContainer position="top-center" autoClose={3000} />
      </CarritoProvider>
    </Router>
  </React.StrictMode>
);
